import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  CircularProgress,
  FormControl,
  Popover,
  makeStyles,
} from '@material-ui/core';
import clsx from 'clsx';
import { Button } from '../../atomicComponents';
import styles from './AddTyerAndothersForm.module.css';
import { withAllowedOperationsProvider } from '../../hocs';
import { RESOURCE_TYPE } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { buildErrorMessage } from '../../apis/calls';

const AddTyerAndothersForm = ({
  open,
  anchorEl,
  closeForm,
  asns,
  reloadData,
  isLoading,
  activeTyreAndOthersRequest,
  classNames,
}) => {
  const { showSuccess, showInternalError, showLoading, closePopUp } =
    usePopupManager();

  const [selectedValue, setSelectedValue] = useState(true);
  const [tyre, setTyre] = useState('');
  const [otherRemark, setOtherRemark] = useState('');

  const handleValueChange = (e) => {
    setSelectedValue(e.target.value === 'true');
  };

  const handleApply = async () => {
    try {
      showLoading();
      await activeTyreAndOthersRequest(asns, {
        tyre,
        otherRemark,
      });
      closeForm();
      reloadData();
      closePopUp();
      showSuccess({
        contextText: 'Tyre & Other remarks updated successfully',
      });
    } catch (error) {
      console.error(buildErrorMessage(error));
      showInternalError();
    }
  };

  const useStyles = makeStyles(() => ({
    backDrop: {
      backdropFilter: 'blur(3px)',
      backgroundColor: 'rgba(0,0,30,0.4)',
    },
  }));

  const classes = useStyles();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={closeForm}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      className={clsx(styles.paper, classNames?.assignShiftFormPaper)}
      BackdropProps={{
        classes: { root: classes.backDrop },
      }}
    >
      {isLoading ? (
        <div className={clsx(styles.loaderIcon, styles.formBox)}>
          <CircularProgress />
        </div>
      ) : (
        <FormControl className={styles.formBox}>
          <div className={styles.formTitleNew}>
            <span className={styles.formTitle}>Add Tyre And Others</span>
            <div className={styles.formlLineDiv} />
          </div>

          <Box
            bgcolor="#dadada3d"
            paddingTop="8px"
            paddingBottom="8px"
            borderRadius="6px"
            style={{ marginBottom: '12px' }}
          >
            <div className={styles.labelfield}>
              <label className={styles.label}>
                Tyre
              </label>
            </div>
            <div className={styles.inputText}>
              <input
                type="text"
                placeholder='Enter Tyre'
                value={tyre}
                onChange={(e) => setTyre(e.target.value)}
                className={styles.textfield}
              />
            </div>
            <div className={styles.labelfield}>
              <label className={styles.label}>
                Other Remarks
              </label>
            </div>
            <div className={styles.inputText}>
              <input
                type="text"
                placeholder='Other Remarks'
                value={otherRemark}
                onChange={(e) => setOtherRemark(e.target.value)}
                className={styles.textfield}
              />
            </div>
          </Box>

          <div style={{ float: 'right' }}>
            <Button
              variant="primary"
              className={clsx(styles.button, styles.applyOrCloseButton)}
              onClick={handleApply}
            >
              APPLY
            </Button>
          </div>
        </FormControl>
      )}
    </Popover>
  );
};

AddTyerAndothersForm.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.any,
  closeForm: PropTypes.func.isRequired,
  asns: PropTypes.array.isRequired,
  reloadData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  activeTyreAndOthersRequest: PropTypes.func.isRequired,
  classNames: PropTypes.object,
};

export default withAllowedOperationsProvider(
  AddTyerAndothersForm,
  false,
  RESOURCE_TYPE.CHASSIS,
);
